import { GET_PROVINSI, SET_LOADING_PROVINSI, SET_PAGINATION_PROVINSI } from '../constant';

const initialState = {
  provinsi: [],
  provinsiPagination: 0,
  loadingProvinsi: false,
  totalProvinsi: 0,
};

const provinsiReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_PROVINSI: {
      return {
        ...state,
        loadingProvinsi: action?.payload,
      };
    }
    case SET_PAGINATION_PROVINSI: {
      return {
        ...state,
        provinsiPagination: action?.payload,
      };
    }
    case GET_PROVINSI: {
      return {
        ...state,
        provinsi: action?.payload?.data || [],
        totalProvinsi: action?.payload?.total,
        loadingProvinsi: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default provinsiReducer;
